import React from "react";
import { Card, Statistic, Skeleton, Flex } from "antd";
import InfoHint from "./InfoHint";

// Compact metric card used on the Home dashboard and elsewhere.
// Pass `tooltip` to show a small info icon next to the title explaining
// what the metric means.
export default function StatCard({
  title,
  value,
  prefix,
  suffix,
  valueStyle,
  icon,
  accent = "#2f54eb",
  loading = false,
  onClick,
  footer,
  tooltip,
}) {
  const titleNode = tooltip ? (
    <span>
      {title}
      <InfoHint title={tooltip} />
    </span>
  ) : (
    title
  );
  return (
    <Card
      hoverable={!!onClick}
      onClick={onClick}
      styles={{ body: { padding: 18 } }}
      style={{ height: "100%", borderRadius: 12 }}
    >
      <Flex justify="space-between" align="flex-start">
        <div style={{ flex: 1 }}>
          {loading ? (
            <Skeleton active paragraph={false} title={{ width: "70%" }} />
          ) : (
            <Statistic
              title={titleNode}
              value={value}
              prefix={prefix}
              suffix={suffix}
              valueStyle={{ fontWeight: 600, fontSize: 26, ...valueStyle }}
            />
          )}
          {footer && <div style={{ marginTop: 6 }}>{footer}</div>}
        </div>
        {icon && (
          <Flex
            align="center"
            justify="center"
            style={{
              width: 44,
              height: 44,
              borderRadius: 10,
              background: `${accent}14`,
              color: accent,
              fontSize: 22,
            }}
          >
            {icon}
          </Flex>
        )}
      </Flex>
    </Card>
  );
}
